/**
 * @generated SignedSource<<69e8b5b42e54e69806bab8a8f21449ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type StatusField_User$data = {
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentType": "StatusField_User";
};
export type StatusField_User$key = {
  readonly " $data"?: StatusField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a3258056fba0005bfde48ba432ba2d81";

export default node;
